<template>
    <div>
        <!--begin::Notice-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12 col-md-7 col-lg-6 col-centered create-report-card">
                    <div class="card p-4 pb-9">
                        <div class="col-centered text-center">
                            <img alt="icon" class="pt-9" src="/media/misc/report-created.png" width="80"/>
                            <div class="custom-title-min-width pt-7">
                                Congratulations your timeproof report has been uploaded
                            </div>
                        </div>
                        <div class="p-10">
                            <div class="OR-line">
                                <div class="OR-Wrap">
                                    <div class="OR font-weight-bold">Or</div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <a @click="downloadPdf()" class="btn btn-success font-weight-bold report-created-btn"
                               href="#" :class="{'disabled': utils.is_pdf_downloading}">
                                <div v-if="!utils.is_pdf_downloading" style="margin: 0 auto;">Download Report</div>
                                <div v-else style="margin: 0 auto;">Downloading Report...</div>
                                <div style="position: absolute;right: 5px;top: 1px;">
                                    ZIP <i class="mdi mdi-arrow-down"></i>
                                </div>
                            </a>
                        </div>
                    </div>
                    <!--end::Notice-->
                </div>
            </div>
        </div>
    </div>
</template>


<script>

   import {mapGetters} from 'vuex';
   import {TIMEPROOF_DOWNLOAD_PDF} from '../../core/store/modules/report.timeproof';

   export default {
      data() {
         return {
            utils: {
               is_pdf_downloading: false,
            }
         };
      },
      computed: {
         ...mapGetters([
            'reportFields',
         ]),
      },
      methods: {
         downloadPdf() {
            this.startDownloadingProcess();
            this.$store.dispatch(TIMEPROOF_DOWNLOAD_PDF, this.reportFields.id).then((res) => {
               this.stopDownloadingProcess(res);
            }).catch((err) => {
               this.stopDownloadingProcess(err);
               alert('download encountered error, please try again');
            })
         },
         startDownloadingProcess() {
            this.utils.is_pdf_downloading = true;
         },
         stopDownloadingProcess(r) {
            console.log(r);
            this.utils.is_pdf_downloading = false;
         }
      }
   };
</script>

<style scoped>
    .disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }
</style>